import React, { useEffect, useState } from "react";
import { SiteTitle } from "../SiteTitle";
import { api_url } from "../globalFunction/global_string";

function LocalNetComparisonData() {
  const [groupedData, setGroupedData] = useState([]); // 存儲處理後的分組數據

  // Function to process the fetched data
  const processLocalNetData = (rawData) => {
    const processed = rawData.reduce((acc, item) => {
      // 如果網域名稱已存在，增加rowCount，否則初始化
      if (acc[item.local_net_name]) {
        acc[item.local_net_name].rowCount += 1;
        acc[item.local_net_name].units.push({
          local_unit_name: item.local_unit_name,
          local_unit_id: item.local_unit_id,
        });
      } else {
        acc[item.local_net_name] = {
          local_net_name: item.local_net_name,
          local_net_id: item.local_net_id,
          rowCount: 1,
          units: [{
            local_unit_name: item.local_unit_name,
            local_unit_id: item.local_unit_id,
          }],
        };
      }
      return acc;
    }, {});
    return Object.values(processed);
  };

  // Function to fetch POST request
  const fetchLocalNetData = async (userType) => {
    const formData = new FormData();
    formData.append('user_type', userType);
    let apiUrl = api_url + "/api/Async/GetlocalNetData";
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Authorization": localStorage.getItem('accessToken') },
        body: formData
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const jsonData = await response.json();
      if (Array.isArray(jsonData.row)) {
        const processedData = processLocalNetData(jsonData.row);
        setGroupedData(processedData); // Set the state with the processed data
      } else {
        console.error('Data is not an array');
      }
    } catch (error) {
      console.error('Fetching local net data failed: ', error);
    }
  };

  // useEffect to execute on component mount
  useEffect(() => {
    const userType = localStorage.getItem('login_user_type');
    fetchLocalNetData(userType);
  }, []);

  return (
    <div className="container mt-5 text-center"> {/* 加入 text-center 進行文字置中 */}
      <SiteTitle />
      <h1 className="mb-3">網域與單位對照表</h1>
      <div className="table-responsive">
        <table className="table table-striped table-bordered table-hover">
          <thead className="thead-dark">
            <tr>
              <th>網域</th>
              <th>網域代碼</th>
              <th>單位</th>
              <th>單位代碼</th>
            </tr>
          </thead>
          <tbody>
            {groupedData.map((domain, domainIndex) => (
              domain.units.map((unit, unitIndex) => (
                <tr key={`${domain.local_net_name}-${unit.local_unit_id}`}>
                  {unitIndex === 0 && (
                    <>
                      <td rowSpan={domain.rowCount} className="align-middle text-center">{domain.local_net_name}</td>
                      <td rowSpan={domain.rowCount} className="align-middle text-center">{domain.local_net_id}</td>
                    </>
                  )}
                  <td className="align-middle text-center">{unit.local_unit_name}</td>
                  <td className="align-middle text-center">{unit.local_unit_id}</td>
                </tr>
              ))
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default LocalNetComparisonData;
